import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";

import App from "./App";
import { UserPermission } from './page/usms/components/UserPermission';

// style of weui
import "weui";
import "react-weui/build/packages/react-weui.css";

import * as ConstInit from "./utils/initConstAjax";

// fastclick
import initReactFastclick from "react-fastclick";
initReactFastclick();

if (window.location.pathname.indexOf("/usms/") > -1) {
	ReactDOM.render(
		<Router>
			<UserPermission>
				<App />
			</UserPermission>
		</Router>,
		document.getElementById("root")
	);
} else {
	Promise.all([
		ConstInit.initDemo()
	]).then(() => {
		ReactDOM.render(
			<Router>
				<App />
			</Router>,
			document.getElementById("root")
		);
	})
};